module.exports = __webpack_public_path__ + "img/pdf.5a9681c8.svg";